import FoldersTable from '../../components/document/FoldersTable'
import FilesTable from '../../components/document/FilesTable'
import FolderOperations from '../../components/document/FolderOperations'
import {loadFolders} from '../../redux/documentSlice'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'

function DocumentsPage() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch<any>(loadFolders())
  }, [])
  return (
    <div className='w-100'>
      <FolderOperations />

      <div className='row'>
        <div className='col-xl-3'>
          <div className='accordion accordion-icon-toggle' id='kt_accordion_2'>
            <FoldersTable />
          </div>
        </div>
        <div className='col-xl-9'>
          <div className='accordion accordion-icon-toggle' id='kt_accordion_2'>
            <FilesTable />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DocumentsPage
